/**
 * Zod schemas for artifact types (GRPO-compliant: Zod-first validation)
 *
 * @packageDocumentation
 */

import { z } from 'zod';

/**
 * Zod schema for ArtifactKind
 */
export const zArtifactKind = z.enum(['table', 'timeseries', 'geojson', 'json', 'text']);

/**
 * Zod schema for Citation
 */
export const zCitation = z.object({
  title: z.string(),
  source: z.string(),
  snippet: z.string().optional(),
  accessedAt: z.string().optional()
});

/**
 * Zod schema for Provenance
 */
export const zProvenance = z.object({
  createdBy: z.string(),
  citations: z.array(zCitation),
  sourceTool: z.string().optional(),
  sourceIteration: z.number().optional(),
  sourceChatId: z.string().optional()
});

/**
 * Zod schema for Artifact
 */
export const zArtifact = z.object({
  id: z.string(),
  name: z.string(),
  kind: zArtifactKind,
  value: z.unknown(),
  provenance: zProvenance,
  createdAt: z.string(),
  hash: z.string()
});

/**
 * Zod schema for ArtifactGraph metadata
 */
export const zArtifactGraphMetadata = z.object({
  totalCount: z.number(),
  lastUpdated: z.string().optional(),
  version: z.string()
});
